import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { setSessionExpiredHandler } from './api/client'
import { useAuthStore } from './stores/auth'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Když vyprší i refresh token, vyhodíme uživatele na login s návratovou cestou.
setSessionExpiredHandler(() => {
  const auth = useAuthStore(pinia)
  if (!auth.isAuthenticated) return

  auth.clear()
  const current = router.currentRoute.value
  void router.push({
    name: 'login',
    query: current.meta.public ? undefined : { redirect: current.fullPath, expired: '1' },
  })
})

app.mount('#app')
